module.exports = __webpack_public_path__ + "images/null-groups.349e2e0da63fddcc09a5e3ed97676571.png";